import {ObjectStatus, ParkingStatus, ResidenceType} from "features/search/filters/enums";
import {SearchResult} from "features/search/types";

export const sortByObjectStatus = (a: SearchResult, b: SearchResult) => {
    return a.objectStatus === b.objectStatus
        ? 0
        : objectStatusOrder(a.objectStatus) > objectStatusOrder(b.objectStatus)
            ? 1
            : -1;
};

export const sortBy = (key: string, a: SearchResult, b: SearchResult) => {
    const aValue = a[key];
    const bValue = b[key];
    return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
};

export const getFilteredData = (objects: SearchResult[], hideSold: boolean = false) => {
    if (!objects) return [];

    if(hideSold) {
        return objects.filter((object) => object.objectStatus !== ObjectStatus.SOLD && object.objectStatus !== ObjectStatus.SHOWING_APARTMENT);
    }

    return objects.filter((object) => object.objectStatus !== ObjectStatus.SHOWING_APARTMENT);
};

export const getDefaultSorting = (constructionForm: ResidenceType, currentNumberOfRooms?: number) => {
    //OBJECTS
    const sortFunction = currentNumberOfRooms && constructionForm !== ResidenceType.PLOT ?
        {
            id: 'rooms',
            desc: false,
            sortMethod: (a: SearchResult, b: SearchResult) => {
                const key = 'rooms';

                let aValue = a[key];
                let bValue = b[key];

                if(currentNumberOfRooms === a[key]) aValue = 0; else aValue = aValue*10;
                if(currentNumberOfRooms === b[key]) bValue = 0; else bValue = bValue*10;

                if(a.objectStatus === ObjectStatus.FOR_SALE || a.objectStatus === ObjectStatus.PRESELLING) aValue--;
                if(b.objectStatus === ObjectStatus.FOR_SALE || b.objectStatus === ObjectStatus.PRESELLING) bValue--;

                return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
            },
            secondSortMethod: (a: SearchResult, b: SearchResult) => {
                return sortBy("price", a, b);
            }
        } :
        //PROJECTS not plot
        constructionForm !== ResidenceType.PLOT ?
            {
                id: 'objectStatus',
                desc: false,
                sortMethod: (a: SearchResult, b: SearchResult) => {
                    return sortByObjectStatus(a, b);
                },
                secondSortMethod: (a: SearchResult, b: SearchResult) => {
                    return sortBy("rooms", a, b);
                },
                thirdSortMethod: (a: SearchResult, b: SearchResult) => {
                    return sortBy("price", a, b);
                }
            } :
            //PROJECTS plot
            {
                id: 'objectStatus',
                desc: false,
                sortMethod: (a: SearchResult, b: SearchResult) => {
                    return sortByObjectStatus(a, b);
                },
                secondSortMethod: (a: SearchResult, b: SearchResult) => {
                    return sortBy("apartmentNumber", a, b);
                }
            };

    return sortFunction;
};

export const objectStatusOrder = (guid: ObjectStatus) => {
    switch (guid) {
        case ObjectStatus.SOLD:
            return 400;
        case ObjectStatus.BOOKED:
            return 300;
        case ObjectStatus.RESERVED:
            return 200;
        case ObjectStatus.PRESELLING:
            return 150;
        case ObjectStatus.FOR_SALE:
            return 100;
        default:
            return 100;
    }
};

export const parkingStatusOrder = (guid: ParkingStatus) => {
    switch (guid) {
        case ParkingStatus.INCLUDED:
            return 100;
        case ParkingStatus.TWO_INCLUDED:
            return 200;
        case ParkingStatus.CAN_PURCHASE:
            return 300;
        case ParkingStatus.CANNOT_PURCHASE:
            return 400;
        case ParkingStatus.UNKNOWN:
            return 500;
        default:
            return 500;
    }
};

// Other utility functions...
